<template>
  <div>
<h6>Created: {{order.created_at | moment('DD-MM-YYYY')}}</h6>
    <h4> ID: {{order.product.name}} 
 
    </h4>
    <h5>Expiry: {{order.expiry_date | moment('DD-MM-YYYY')}} <br /><small>{{order.expiry_date | moment('from')}}</small></h5>
   


    <!--</div>-->

  </div>
</template>
<script>
export default {
  props: ["order"],
  methods: {
    handleEditClick(id) {
      this.$router.push({ path: "/order/edit/" + id });
    },
    handleDeleteClick() {
      this.$emit("on-delete", this.index);
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Customers/CustomerProfile/Order.vue